import './InfoCallout.css';

import React from 'react';

import LightbulbIcon from '../LightbulbIcon';

interface InfoCalloutProps {
  /** Optional icon override; defaults to a lightbulb. */
  icon?: React.ReactNode;
  /** Body content (string or rich nodes). */
  children: React.ReactNode;
  /** Additional class for layout / width-management overrides. */
  className?: string;
}

/**
 * Pale-yellow tip / info banner. Icon on the left, text on the right.
 * Keep messages short (one or two sentences).
 */
const InfoCallout: React.FC<InfoCalloutProps> = ({
  icon,
  children,
  className = '',
}) => (
  <div className={`info-callout ${className}`.trim()} role="note">
    <span className="info-callout-icon" aria-hidden="true">
      {icon ?? <LightbulbIcon />}
    </span>
    <p className="info-callout-text">{children}</p>
  </div>
);

export default InfoCallout;
